import { BACKEND_URL } from "@/lib/api";

export const SITE_STATUS = {
  bozza: ["Bozza", "bg-slate-100 text-slate-600 border-slate-200"],
  anteprima: ["Anteprima", "bg-sky-50 text-sky-700 border-sky-200"],
  online: ["Online", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  sospeso: ["Sospeso", "bg-amber-50 text-amber-800 border-amber-200"],
  archiviato: ["Archiviato", "bg-slate-100 text-slate-400 border-slate-200"],
};

export const DEPLOY_STATUS = {
  queued: ["In coda", "bg-slate-100 text-slate-600"],
  building: ["In compilazione", "bg-sky-50 text-sky-700"],
  ready: ["Pronta", "bg-emerald-50 text-emerald-700"],
  failed: ["Non riuscita", "bg-red-50 text-red-700"],
  cancelled: ["Annullata", "bg-slate-100 text-slate-500"],
  archived: ["Archiviata", "bg-slate-100 text-slate-400"],
};

export const pending = (d) => d && ["queued", "building"].includes(d.status);
export const publicUrl = (path) => (/^https?:\/\//.test(path || "") ? path : `${BACKEND_URL}${path}`);

export function totalKb(summary) {
  const s = summary?.sizes_kb;
  if (!s) return null;
  return Math.round(Object.values(s).reduce((a, b) => a + (b || 0), 0));
}

export function duration(a, b) {
  if (!a || !b) return "—";
  const s = Math.max(0, (new Date(b) - new Date(a)) / 1000);
  return s < 60 ? `${s.toFixed(1).replace(".", ",")} s` : `${Math.floor(s / 60)} min ${Math.round(s % 60)} s`;
}
